import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-fluid" }
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = { class: "p-grid" }
const _hoisted_5 = { class: "p-fluid" }
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_Accordion = _resolveComponent("Accordion")

  return (_ctx.physicalModel)
    ? (_openBlock(), _createBlock(_component_Accordion, {
        key: 0,
        multiple: true,
        activeIndex: [0]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AccordionTab, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('metaweb.physicalModel.misc')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode("div", _hoisted_1, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.metawebPropertyListTabDescriptor.physicalModelInfo, (modelInfo, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "p-col-6",
                    key: index
                  }, [
                    _createVNode("div", _hoisted_2, [
                      _createVNode("div", _hoisted_3, [
                        _createVNode("label", {
                          for: modelInfo.name,
                          class: "kn-material-input-label"
                        }, _toDisplayString(_ctx.$t(modelInfo.label)), 9, ["for"]),
                        _createVNode(_component_InputText, {
                          class: "kn-material-input",
                          modelValue: _ctx.physicalModel[modelInfo.name],
                          "onUpdate:modelValue": ($event: any) => (_ctx.physicalModel[modelInfo.name] = $event),
                          id: modelInfo.name,
                          disabled: true,
                          "data-test": 'input-' + modelInfo.label
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "data-test"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(Object.keys(_ctx.categories), (categoryKey, index) => {
            return (_openBlock(), _createBlock(_component_AccordionTab, { key: index }, {
              header: _withCtx(() => [
                _createVNode("span", null, _toDisplayString(categoryKey), 1)
              ]),
              default: _withCtx(() => [
                _createVNode("div", _hoisted_4, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories[categoryKey], (prop, index) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "p-col-6",
                      key: index
                    }, [
                      _createVNode("div", _hoisted_5, [
                        _createVNode("div", _hoisted_6, [
                          _createVNode("label", _hoisted_7, _toDisplayString(prop.propertyType.name), 1),
                          _createVNode(_component_InputText, {
                            class: "kn-material-input",
                            modelValue: prop.value,
                            "onUpdate:modelValue": ($event: any) => (prop.value = $event),
                            disabled: true,
                            "data-test": 'input-' + prop.propertyType.name
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "data-test"])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}